const isProd = typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'production';

export default {
  server: 'https://admin.lalaenglish.com.ua/index.php/',
  server_img: 'https://admin.lalaenglish.com.ua/',
  google_key: 'AIzaSyA1e-85hAFjfVtFPOw7AVh1BF7d6IwDmFA',
  slides_key: 'AIzaSyAVsNGZzAU6lrBkhcUHt6gQxcZROvlGmw4',
  slides_script_url: 'https://script.google.com/macros/s/AKfycbz6CwiHcXJySBTfUc5RLXhfRLeb43c0L3ekLk49oiN-Mx1HVjXoGa29JZ-kVYe3FTeA/exec',
  apiLog: !isProd,
};